import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';

/**
 * Button to open the column customization modal
 * 
 * @param {Object} props
 * @param {Function} props.onClick - Callback when button is clicked
 * @param {string} [props.className] - Additional CSS class names
 */
const ColumnCustomizationButton = ({ onClick, className = '' }) => {
  return (
    <button
      className={`table-settings-button ${className}`.trim()}
      onClick={onClick}
      type="button"
      title="Customize table columns"
    >
      <FontAwesomeIcon icon={faCog} /> Settings
    </button>
  );
};

export default ColumnCustomizationButton;
